var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9685 1.39077C103.206 8.7927 98.148 18.0982 94.8059 24.4884C89.3794 35.8045 81.451 45.7997 71.8084 53.659C56.7155 66.1802 37.6103 72.916 18.0112 73.6469C21.072 74.8782 23.8915 76.0333 26.9524 77.2646C29.5306 78.3437 28.4753 82.5307 25.5795 81.6173C18.0099 78.698 10.3641 76.0206 2.55322 73.0252C0.622694 72.4163 0.343867 69.9355 2.24939 68.9413C11.1293 63.5001 20.1743 58.3769 29.2955 53.0118C31.8362 51.6862 33.8167 55.5014 31.2761 56.827C24.6955 60.8664 17.7974 65.0716 10.9755 69.0349C28.7579 69.858 46.2239 65.7956 61.5193 55.997C70.8693 49.9065 79.0766 42.3921 85.4171 33.2254C90.5885 26.0828 101.325 11.39 98.1393 2.14316C97.7204 0.947563 99.4734 0.436987 99.9685 1.39077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curvedArrow.c01010029e9fc7557d5b10b0910e5a3e.svg";
export { ForwardRef as ReactComponent };